"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _classCallCheck2 = require("babel-runtime/helpers/classCallCheck");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require("babel-runtime/helpers/createClass");

var _createClass3 = _interopRequireDefault(_createClass2);

var _ErrorApi = require("./../../../../utils/ErrorApi");

var _ErrorApi2 = _interopRequireDefault(_ErrorApi);

var _Fetch = require("./../../../../utils/Fetch");

var _Fetch2 = _interopRequireDefault(_Fetch);

var _ParamsFetch = require("./../../../../utils/ParamsFetch");

var _ParamsFetch2 = _interopRequireDefault(_ParamsFetch);

var _JsonFetch = require("./../../../../utils/JsonFetch");

var _JsonFetch2 = _interopRequireDefault(_JsonFetch);

var _generateUrl = require("./../../../../utils/generateUrl");

var _generateUrl2 = _interopRequireDefault(_generateUrl);

var _UpdateMethods = require("./../UpdateMethods");

var UpdateMethods = _interopRequireWildcard(_UpdateMethods);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Rozhraní pro konfiguraci rolí subjektu. Generated from cz.marbes.api.subjekt.v1.conf.SubjektRoleService.
 */
// ##############################################################

// #             GENEROVANÝ KÓD, NEMODIFIKOVAT!!!!              #

// #                  2024-05-22T17:56:38Z                      #

// ##############################################################

var SubjektRoleApi = function () {
  function SubjektRoleApi() {
    (0, _classCallCheck3.default)(this, SubjektRoleApi);
  }

  (0, _createClass3.default)(SubjektRoleApi, null, [{
    key: "getSubjektRoleByKod",

    /**
     * Načtení role subjektu dle kódu.
     *
     * @param kodRole kód role
     * @return načtená role subjektu
     */
    value: function getSubjektRoleByKod(kodRole) {
      var uri = serverContextPath + "/api/subjekt/v1/subjektRole";
      var headers = undefined;
      var params = { kodRole: kodRole };

      return _ErrorApi2.default.responseResolver(_JsonFetch2.default.get(uri, params, headers));
    }

    /**
     * Aktualizace role subjektu.
     *
     * @param kod 
     * @param subjektRoleConf konfigurace role
     * @return aktualizovaná konfigurace role
     */

  }, {
    key: "updateSubjektRoleConf",
    value: function updateSubjektRoleConf(kod, subjektRoleConf) {
      var uri = serverContextPath + ("/api/subjekt/v1/subjektRole/" + kod);
      var headers = undefined;
      var params = {};

      return _ErrorApi2.default.responseResolver(_JsonFetch2.default.put(uri, params, UpdateMethods.updateSubjektRoleConf_60B74Bv1(subjektRoleConf), headers));
    }

    /**
     * Vytvoření nové role subjektu.
     *
     * @param subjektRoleConf konfigurace role
     * @return vytvořená konfigurace role
     */

  }, {
    key: "createSubjektRoleConf",
    value: function createSubjektRoleConf(subjektRoleConf) {
      var uri = serverContextPath + "/api/subjekt/v1/subjektRole";
      var headers = undefined;
      var params = {};

      return _ErrorApi2.default.responseResolver(_JsonFetch2.default.post(uri, params, UpdateMethods.updateSubjektRoleConf_60B74Bv1(subjektRoleConf), headers));
    }
  }]);
  return SubjektRoleApi;
}();

exports.default = SubjektRoleApi;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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